import { realBricksApi } from '../../utils/axiosInterceptors';

export const getFundingSources = async () => {
  const response = await realBricksApi.get(`/api/v1/payment/funding-sources`);
  return response.data;
};

export const makePrimerKey = async (id) => {
  const response = await realBricksApi.put(`/api/v1/payment/set-primary/${id}`);
  return response.data;
};

export const deleteFundingResource = async (id) => {
  const response = await realBricksApi.delete(`/api/v1/payment/${id}`);
  return response.data;
};
